import React from 'react';

import { useTranslate } from 'react-polyglot';

import moment from "moment";

function getUserLocale() {
    let locale = "";
    if (localStorage.getItem("user") != null) {
        let localUser = localStorage.getItem("user");
        if (localUser != null) {
            localUser = JSON.parse(localUser);
            if (localUser != null) {
                if (localUser["userdata"]["language"] != undefined) {
                    locale = localUser["userdata"]["language"].toLowerCase();
                }
            }
        }
    }
    return locale;
}

function DateFormatter(props) {
    const t = useTranslate();

    function dateToi18String(date) {
        let locale = getUserLocale();
        moment.locale(locale, { months: t("localisation.months").split("_") });
        return moment(date).locale(locale).format(t("localisation.datetimeformat_moment"));
    }

    return (<span>{props.date != undefined && props.date != null ? dateToi18String(props.date) : ""}</span>);
}

export default DateFormatter;